import React, { useState, useRef } from "react";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import CodiButton from "../../assets/icons/CodiButton.svg";
import CodiButtonHover from "../../assets/icons/CodiButtonHover.svg";
import CodiOS from "../codiOS/codiOS";

const CodiBubbler = ({ onClick }) => {
  const [open, setOpen] = useState(false);
  const [showOS, setShowOS] = useState(false);
  const [hovered, setHovered] = useState(false);
  const avatarRef = useRef(null);

  const handleBubblerClick = () => {
    if (onClick) onClick();
    setTimeout(() => {
      setShowOS(true);
      requestAnimationFrame(() => setOpen(true));
    }, 100);
  };

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => setShowOS(false), 300);
  };

  return (
    <div className="relative flex justify-center w-full">
      <motion.button
        ref={avatarRef}
        onClick={handleBubblerClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className="focus:outline-none"
        whileHover={{
          scale: 1.1,
          rotate: [0, -3, 3, 0], 
        }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 300, damping: 15 }}
      >
        <motion.img
          key={hovered ? "hover" : "default"}
          src={hovered ? CodiButtonHover : CodiButton}
          alt="Codi Button"
          className="max-w-[80%] h-auto"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ duration: 0.2 }}
          style={{
            filter: "drop-shadow(0 6px 14px rgba(0,0,0,0.25))"
          }}
        />
      </motion.button>

      {typeof window !== "undefined" &&
        createPortal(
          <AnimatePresence>
            {showOS && (
              <motion.div
                initial={{ opacity: 0, scale: 0.3, y: 200 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.92, y: 60 }}
                transition={{ type: "spring", stiffness: 200, damping: 25 }}
                className="fixed inset-0 z-[9999] bg-black/30 backdrop-blur-sm"
              >
                <CodiOS onClose={handleClose} autoGreet />
              </motion.div>
            )}
          </AnimatePresence>,
          document.body
        )}
    </div>
  );
};

export default CodiBubbler;
